import { useRecoilState } from "recoil";
import myInfoState from "../../atoms/myinfo";
import waitingRoomState, { RoomsSortingType } from "../../atoms/waiting-room";
import "./WaitingRoomHeader.scoped.scss"
import { openAlert, openSelectbox } from "../../atoms/common";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

function WaitingRoomHeader() {
  const [myInfo] = useRecoilState(myInfoState);
  const [waitingRoom, setWaitingRoom] = useRecoilState(waitingRoomState);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('kick')) {
      openAlert('방에서 강제 퇴장 당하였습니다.');
    }
  }, []);

  const enterMyRoom = () => {
    if (myInfo.userDetail == null || myInfo.userDetail.id === '') {
      openAlert('로그인 후 이용해주세요.');
      return;
    }
    if (myInfo.ownRoomId === '' || myInfo.ownRoomId == null) {
      openAlert('생성된 방이 없습니다.');
      return;
    }

    const roomIdList = myInfo.ownRoomId.split('|');
    if (roomIdList.length === 1) {
      window.location.href = `/chatting-app/room/${myInfo.ownRoomId}`;
    } else {
      openSelectbox(
        '입장할 방을 선택해주세요.',
        myInfo.ownRoomName!.split('|'),
        myInfo.ownRoomId.split('|').map((roomId) => () => {
          window.location.href = `/chatting-app/room/${roomId}`;
        }),
      )
    }
  }

  const openCreatingRoomModal = () => {
    if (myInfo.userDetail == null || myInfo.userDetail.id === '') {
      openAlert('로그인 후 이용해주세요.');
      return;
    }
    setWaitingRoom({
      ...waitingRoom,
      isOpenedCreatingRoom: true,
    })
  }

  return (
    <div className="waiting-room-header">
      <b className="waiting-room-header__title">채팅 대기실</b>
      <div className="waiting-room-header__sort">
        <button 
          className={`waiting-room-header__sort-button ${waitingRoom.roomsSorting === RoomsSortingType.SORT_IN_PARTICIPANTS ? 'sort-button--active' : ''}`}
          onClick={() => setWaitingRoom({ ...waitingRoom, roomsSorting: RoomsSortingType.SORT_IN_PARTICIPANTS })}
        >
          👪참여자순
        </button>
        <button 
          className={`waiting-room-header__sort-button ${waitingRoom.roomsSorting === RoomsSortingType.SORT_IN_NEWER ? 'sort-button--active' : ''}`}
          onClick={() => setWaitingRoom({ ...waitingRoom, roomsSorting: RoomsSortingType.SORT_IN_NEWER })}
        >
          🆕최신순
        </button>
        <button 
          className={`waiting-room-header__sort-button ${waitingRoom.roomsSorting === RoomsSortingType.SORT_IN_RECOMMENDERS ? 'sort-button--active' : ''}`}
          onClick={() => setWaitingRoom({ ...waitingRoom, roomsSorting: RoomsSortingType.SORT_IN_RECOMMENDERS })}
        >
          👍좋아요순
        </button>
        {/* <button 
          className={`waiting-room-header__sort-button ${waitingRoom.roomsSorting === RoomsSortingType.SORT_IN_SCORE ? 'sort-button--active' : ''}`}
          onClick={() => setWaitingRoom({ ...waitingRoom, roomsSorting: RoomsSortingType.SORT_IN_SCORE })}
        >
          👆랭킹순
        </button> */}
{/*        <button 
          className={`waiting-room-header__sort-button ${waitingRoom.roomsSorting === RoomsSortingType.SORT_IN_GIFTED_BULLETS ? 'sort-button--active' : ''}`}
          onClick={() => setWaitingRoom({ ...waitingRoom, roomsSorting: RoomsSortingType.SORT_IN_GIFTED_BULLETS })}
        >
          🪙선물받은 보석순
        </button>*/}
      </div>
      <div>
        <button
          className="waiting-room-header__entering-my-room-button"
          onClick={enterMyRoom}
        >
          나의 채팅방입장하기
        </button>
        <button 
          className="waiting-room-header__creating-room-button"
          onClick={openCreatingRoomModal}
        >
          채팅방개설하기
        </button>
      </div>
    </div>
  );
}

export default WaitingRoomHeader;
